
// import React, { useEffect, useState } from "react"
import './CategoryUiSection.css';
// import Hola9logo from '../images/Hola9-logo.jpg';


const CategoryUiSection = () => {

 
  return (
    <>

<section
  className="ftco-intro ftco-no-pt ftco-no-pb img"
  style={{
    backgroundImage: "url(images/xbg_4.jpg.pagespeed.ic.RltLC5r6zR.webp)"
  }}
>
  <div className="overlay" />
  <div className="container-xl py-5">
    <div className="row justify-content-center">
      <div className="col-lg-10 col-xl-8">
        <div className="row">
          <div className="col-md-8 d-flex align-items-center">
            <div>
              <h1 className="mb-0">Find Best Place For Leaving</h1>
              <p>Find Best Place For Leaving</p>
            </div>
          </div>
          <div className="col-md-4 d-flex align-items-center">
            <p className="mb-0">
              <a href="#" className="btn btn-black py-3 px-4">
                Get in touch
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


    
    </>
  )
}

export default CategoryUiSection
